


/* Built In Imports */
import { useState } from 'react';

/* External Imports */
import { Box, Image, List } from '@chakra-ui/react';
import Slider from 'react-slick';

/* Internal Imports */
/* Components */
import { NextArrow, PrevArrow } from '@components/Sliders/TestimonialYs/Icons';
//styles
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser13';
import { render } from 'datocms-structured-text-to-html-string';
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";

import { useMediaQuery } from 'react-responsive';

/**
 * Renders the Testimonial component.
 *
 * @returns {ReactElement} Testimonial component.
 */

const ProgramCard = ({ sectionContent, pageData, region, lang }) => {

    const isMobile = useMediaQuery({ maxWidth: 767 });
    const Card = ({ section, maxWidth }) => (
        <Box
            display="flex"
            flexDirection="column"
            justifyContent={'flex-start'}
            alignItems={"center"}
            key={section.id}
            maxWidth={maxWidth}
            textAlign={"center"}
            mx={"auto"}
        >
            <Box mb={{ base: 4, md: 4 }}>
                <Image
                    src={section.thumbnail?.url}
                    title={section.thumbnail?.title}
                    alt={section.thumbnail?.alt}
                    maxWidth={{ base: 190, md: 270 }}
                />
            </Box>

            <Box
                as="h2"
                width={"180px"}
                fontSize={{ base: '18px', md: '18px' }}
                color="#433F3C"
                fontWeight={"600"}
                fontFamily={"FedraSansStd-book"}
                // whiteSpace={"nowrap"}
                mb={"12px"}
                textAlign={"center"}
                lineHeight={'23.4px'}
            >
                {section.title}
            </Box>
            <Box
                as="p"
                fontFamily="FedraSansStd-book"
                fontSize="16px"
                fontWeight={"400"}
                color="#6D6358"
                lineHeight={'24px'}
                letterSpacing={'-0.5%'}
            >
                <StructuredTextParser
                    str={render(section.description)}
                    textAlign="center"
                    mt="0"
                />
            </Box>
        </Box>
    );
    const [imgIndex, setImgIndex] = useState(0);
    const settings = {
        dots: true,
        infinite: true,
        arrows: false,
        lazyLoad: true,
        autoplay: false,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 2,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        className: "Yoga-SandhyaTestimonial",
        appendDots: dots => (
            <Box h="1px">
                <List marginTop='20px'> {dots} </List>
            </Box>
        ),
        customPaging: () => (
            <Box
                background={'#D2C8B5'}
                width="12px"
                rounded="full"
                height="12px"
            ></Box>
        ),
        afterChange: (index) => setImgIndex(index),
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 1,
                },
            },
            {
                breakpoint: 1065,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,

                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerPadding: '40px 0px 0px ',
                    centerMode: true,

                }
            }
        ],
    };

    return (
        <Box
            w="100%"
            pb={{ base: '10px', sm: "30px", md:'2px', lg:'2px'}}
        >
            {
                isMobile ?
                    <Box
                        display={"flex"}
                        justifyContent="center"
                        flexDir="column"
                        textAlign={"center"}
                        ml={{ base: "40px", sm: "40px", xl: "0" }}

                    >
                        <Slider {...settings}>
                            {sectionContent?.cards?.map((section, index) => (
                                <Card

                                    section={section}
                                    maxWidth={{ base: "240px", md: "255px" }}
                                />
                            ))}
                        </Slider>
                    </Box> :
                    <Box
                        display="flex"
                        flexWrap="wrap"
                        //gap={"70px"}
                        justifyContent="center"
                        textAlign="center"
                        my={4}

                    >
                        {sectionContent?.cards?.map((section, index) => (
                            <Card section={section} maxWidth={{ base: 302, md: "255px" }} />
                        ))}
                    </Box>
            }
                  <style global jsx>
          {`
            .slick-dots li {
              width: 10px !important;
            }
         `}
      </style>
        </Box>
    );
};

export default ProgramCard;
